import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';

function Navigation() {
  const accessToken = Cookies.get('access_token');

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200/50 dark:border-gray-800/50 bg-background-light/80 dark:bg-background-dark/80 backdrop-blur-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-4">
            <img src="/favicon-32x32.png" alt="Dissona" className="size-6" />
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">
              Dissona
            </h2>
          </Link>
          <nav className="hidden items-center gap-8 md:flex">
            {/*
            <NavLink href="#">Product</NavLink>
            <NavLink href="#">Pricing</NavLink>
            <NavLink href="#">Resources</NavLink>
            */}
          </nav>
          <div className="flex items-center gap-2">
            {accessToken ? (
              <Link
                to="/dashboard"
                className="flex h-10 items-center justify-center rounded-lg bg-primary px-4 text-sm font-bold text-white hover:bg-primary/90 transition-colors"
              >
                <span className="truncate">Dashboard</span>
              </Link>
            ) : (
              <Link
                to="/login"
                className="flex h-10 items-center justify-center rounded-lg bg-primary/30 px-4 text-sm font-bold text-white hover:bg-primary/40 transition-colors"
              >
                <span className="truncate">Log in</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navigation;
